import { render } from "./social-account-auth-buttons.vue?vue&type=template&id=b2408c6a"
import script from "./social-account-auth-buttons.vue?vue&type=script&lang=js"
export * from "./social-account-auth-buttons.vue?vue&type=script&lang=js"

import "./social-account-auth-buttons.vue?vue&type=style&index=0&id=b2408c6a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__